var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 1C4.65196 1 1.66663 3.95467 1.66663 7.6C1.66663 10.5427 2.83329 17.5267 14.3173 24.5867C14.523 24.7118 14.7592 24.778 15 24.778C15.2408 24.778 15.4769 24.7118 15.6826 24.5867C27.1666 17.5267 28.3333 10.5427 28.3333 7.6C28.3333 3.95467 25.348 1 21.6666 1C17.9853 1 15 5 15 5C15 5 12.0146 1 8.33329 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0e6c6a58ddca82181f133adc11f9160b.svg";
export { ForwardRef as ReactComponent };